import {ApiService} from "./api.service";

export class PaymentProcessorsService extends ApiService {
  constructor(organizationId) {
    super();
    this.endpoint = `/organizations/${organizationId}/processor`;
  }

  async show(id) {
    return super.show(id);
  }

  async index(params, filter = null) { //TODO
    try {
      let response = await this.get(`${this.endpoint}/payment_processors`, params);
      return response.json;
    } catch {
      return {};
    }
  }

  async update(id, params) {
    try {
      let url = `${this.endpoint}/stripe_processors/${id}`;

      let response = await this.patch(url, params);
      return !this.responseHasErrors(response);
    } catch (e) {
      console.error('error', e);
      return false;
    }
  }

  async configureStripeAccount(params) {
    try {
      let url = `${this.endpoint}/stripe_processors/configure`;
      return await this.post(url, params);
    } catch (e) {
      console.error('error setting up Stripe account', e);
      return null;
    }
  }

  async activePaymentProcessor(params) {
    try {
      let url = `${this.endpoint}/payment_processors/active_processor`;
      const response =  await this.get(url, params);
      return response.json;
    } catch (e) {
      return null;
    }
  }


  async configureHelcimAccount(params) {
    try {
      let url = `${this.endpoint}/helcim_processors/configure`;
      return await this.post(url, params);
    } catch (e) {
      console.error('error setting up Helcim account', e);
      return null;
    }
  }
}
